import {
  FETCH_RECEIVABLES_MASTERDATA,
  FETCH_RECEIVABLES_MASTERDATA_LOADING,
  FETCH_RECEIVABLES_MASTERDATA_ERROR,
  INVALIDATE_RECEIVABLES_MASTERDATA,
} from '../actions/constants';

const defaultState = {
  loading: false,
  invoiceData: {},
  payoutData: {},
  error: null,
  isFetched: false,
};

export default function receivablesMasterDataReducer(
  state = defaultState,
  action,
) {
  switch (action.type) {
    case FETCH_RECEIVABLES_MASTERDATA_LOADING:
      return {
        ...state,
        loading: true,
      };

    case FETCH_RECEIVABLES_MASTERDATA:
      return {
        ...state,
        loading: false,
        invoiceData: action.data.invoiceData,
        payoutData: action.data.payoutData,
        error: null,
        isFetched: true,
      };

    case FETCH_RECEIVABLES_MASTERDATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case INVALIDATE_RECEIVABLES_MASTERDATA:
      return {
        ...state,
        isFetched: false,
        loading: false,
      };

    default:
      return state;
  }
}
